import { Text } from "react-native";
import { Row, semanticColors } from "@louise/moon-ui";
import { EMBER } from "../../../../onboarding/theme";
import { YOU_ILLUSTRATION_SIZE } from "../components";

type Props = {
  icon: React.ReactNode;
  label: string;
  value?: string;
  valueColor?: string;
  divider?: boolean;
  onPress: () => void;
};

export function YouOverviewRow({
  icon,
  label,
  value,
  valueColor,
  divider = false,
  onPress,
}: Props) {
  return (
    <Row
      surface="plain"
      leading={icon}
      leadingSize={YOU_ILLUSTRATION_SIZE}
      title={label}
      trailing={
        value ? (
          <Text
            className="font-dm-sans"
            numberOfLines={1}
            style={{
              flexShrink: 1,
              maxWidth: "45%",
              fontSize: 14,
              lineHeight: 18,
              color: valueColor ?? EMBER.colors.textLight,
              textAlign: "right",
            }}
          >
            {value}
          </Text>
        ) : undefined
      }
      onPress={onPress}
      action="you_overview_row"
      gap={14}
      paddingHorizontal={16}
      paddingVertical={14}
      borderRadius={0}
      titleStyle={{
        fontSize: 15,
        lineHeight: 20,
        fontWeight: "500",
        color: EMBER.colors.text,
      }}
      style={{
        borderRadius: 0,
        borderTopWidth: divider ? 1 : 0,
        borderTopColor: semanticColors.border.strong,
      }}
    />
  );
}
